const ITEMS = [
  "Experience Never Retires",
  "Ages 40–55",
  "Affiliated with IBC",
  "Sanctioned Masters Bouts",
  "Professionals & Freshers",
  "Step Back Through The Ropes",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-zinc-800/80 bg-[#0d0d0d] py-5 overflow-hidden" data-testid="marquee-strip">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-2xl sm:text-3xl tracking-[0.12em] uppercase text-zinc-600 px-6">
                  {t}
                </span>
                <span className="h-2 w-2 rotate-45 bg-[#E10600] shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
